import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'objectives',
	templateUrl: './objectives.component.html',
	styleUrls: ['./objectives.component.scss']
})

export class ObjectivesComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	loading = true
	error = false
	
	@Input() id = 0
	@Input() multitransl: boolean = false
	@Input() transl: string = 'es'
	title = 'Objetivos'
	capabilities: any[] = []

	import = false
	importText = ''
	importLoading = false
	importSuccess = false
	importError = false

	getObjectivesSub = new Subscription
	addCapabilitySub = new Subscription
	addCriteriaSub = new Subscription
	editCapabilitySub = new Subscription
	editCriteriaSub = new Subscription
	deleteCapabilitySub = new Subscription
	deleteCriteriaSub = new Subscription
	importObjectivesTextSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService, private renderer: Renderer2) {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {}

	ngOnChanges(): void {
		this.getObjectives(this.id)
	}

	ngOnDestroy(): void {
		this.getObjectivesSub?.unsubscribe()
		this.addCapabilitySub?.unsubscribe()
		this.addCriteriaSub?.unsubscribe()
		this.editCapabilitySub?.unsubscribe()
		this.editCriteriaSub?.unsubscribe()
		this.deleteCapabilitySub?.unsubscribe()
		this.deleteCriteriaSub?.unsubscribe()
		this.importObjectivesTextSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	showEdit(event: Event) {
		let span = event.currentTarget as HTMLSpanElement
		let edit = span.nextElementSibling as HTMLElement
		this.renderer.addClass(span, 'd-none')
		this.renderer.removeClass(edit, 'd-none')
		edit.focus()
	}

	hideEdit(event: Event) {
		let edit = event.currentTarget as HTMLElement
		let span = edit.previousElementSibling as HTMLSpanElement
		this.renderer.addClass(edit, 'd-none')
		this.renderer.removeClass(span, 'd-none')
	}

	getObjectives(objectives: number) {
		this.loading = true
		this.error = false
		this.import = false
		this.id = objectives
		this.getObjectivesSub = this.dataService.getObjectives(objectives, this.multitransl, this.transl)
		.subscribe({
			next: (data) => {
				// console.log(data)
				this.loading = false
				this.error = false
				this.title = data.name
				this.capabilities = data.capabilities
			},
			error: (_e) => {
				// console.log(e)
				this.loading = false
				this.error = true
			},
		})
	}

	getCapability(id: number) {
		return this.capabilities.find((cap) => {
			return cap.id == id
		})
	}

	addCapability(_event: Event) {
		let code = 'C' + (this.capabilities.length + 1)
		let content = 'Nuevo objetivo específico'

		this.addCapabilitySub = this.dataService.addCapability(this.id, code, content)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.getObjectives(this.id)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	editCapability(event: Event) {
		let input = event.currentTarget as HTMLInputElement
		if (!input.validity.valid) {
			Swal.fire('Error', 'Datos inválidos', 'error')
			return
		}
		
		let capability = +input.dataset.id!
		let field = input.dataset.field!

		let code, content, spanText = undefined
		if (field == 'code') {
			code = input.value
			spanText = input.value + ':'
		} else if (field == 'content') {
			content = input.value
			spanText = input.value
		}

		let span = input.previousElementSibling as HTMLSpanElement
		this.renderer.setProperty(span, 'textContent', spanText)
		this.hideEdit(event)

		this.editCapabilitySub = this.dataService.editCapability(capability, code, content, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	deleteCapability(id: number) {
		Swal.fire({
			title: '¿Seguro?',
			text: '¿Desea eliminar este objetivo específico y sus criterios asociados?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return
			
			this.deleteCapabilitySub = this.dataService.deleteCapability(id)
			.subscribe({
				next: (_data) => {
					// console.log(data)
					this.getObjectives(this.id)
				},
				error: (_e) => {
					// console.log(e)
				},
			})
		})

	}

	addCriteria(event: Event) {
		let button = event.currentTarget as HTMLButtonElement
		let capabilityID = +button.dataset.id!
		let capability = this.getCapability(capabilityID)
		let code = 'CE' + capability.code.replace(/[^0-9]/g, '') + '.' + (capability.criteria.length + 1)
		let content = 'Nuevo criterio específico'

		this.addCriteriaSub = this.dataService.addCriteria(capabilityID, code, content)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.getObjectives(this.id)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	editCriteria(event: Event) {
		let input = event.currentTarget as HTMLInputElement
		if (!input.validity.valid) {
			Swal.fire('Error', 'Datos inválidos', 'error')
			return
		}
		
		let criteria = +input.dataset.id!
		let field = input.dataset.field!

		let code, content, spanText = undefined
		if (field == 'code') {
			code = input.value
			spanText = input.value + ':'
		} else if (field == 'content') {
			content = input.value
			spanText = input.value
		}
		
		let span = input.previousElementSibling as HTMLSpanElement
		this.renderer.setProperty(span, 'textContent', spanText)
		this.hideEdit(event)

		this.editCriteriaSub = this.dataService.editCriteria(criteria, code, content, this.multitransl, this.transl)
		.subscribe({
			next: (_data) => {
				// console.log(data)
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	deleteCriteria(id: number) {
		Swal.fire({
			title: '¿Seguro?',
			text: '¿Desea eliminar este criterio específico?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return

			this.deleteCriteriaSub = this.dataService.deleteCriteria(id)
			.subscribe({
				next: (_data) => {
					// console.log(data)
					this.getObjectives(this.id)
				},
				error: (_e) => {
					// console.log(error)
				},
			})
		})
	}

	importObjectivesText(text: string) {
		// console.log(text)
		this.importLoading = true
		this.importSuccess = false
		this.importError = false

		this.importObjectivesTextSub = this.dataService.importObjectivesText(this.id, 'objectives', text)
		.subscribe({
			next: (_data) => {
				// console.log(data)
				this.importLoading = false
				this.importSuccess = true
				this.importError = false
			},
			error: (_e) => {
				// console.log(error)
				this.importLoading = false
				this.importSuccess = false
				this.importError = true
			}
		})
	}
}
